<template>
  <div class="h-100 d-flex align-center justify-md-space-between justify-center flex-wrap">
    <!-- 👉 Footer: left content -->
    <span class="d-flex align-center d-inline-block text-body-1 text-medium-emphasis">
      &copy;
      {{ new Date().getFullYear() }}
      Made With
      <VIcon
        icon="bx-bxs-heart"
        color="#00BBa7"
        size="1.25rem"
        class="mx-1"
      />
      By <a
        href="https://www.xyte.be/"
        target="_blank"
        rel="noopener noreferrer"
        class="text-primary ms-1"
      >Xyte
        Webdesign</a>
    </span>
    <!-- 👉 Footer: right content -->
    <span class="d-md-flex gap-x-4 text-primary d-none">
      <NuxtLink to="/legal/privacy-gdpr">
        Privacy
      </NuxtLink>
      <NuxtLink to="/legal/cookie-policy">
        Cookies
      </NuxtLink>
      <NuxtLink to="/legal/algemene-voorwaarden">
        Algemene Voorwaarden
      </NuxtLink>
      <NuxtLink to="/legal/toegankelijkheidsverklaring">
        Toegankelijkheid
      </NuxtLink>
    </span>
  </div>
</template>
